import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel, PRODUCTS } from './components/MetaPixel';
import { prefetchPage, whenIdle } from './utils/prefetch';
import { HERO_MOCKUP } from './components/HeaderSections';
const CHECKOUT_ORIGIN = 'https://trening-funkcjonalny-365.impultienda.ar';

// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Polish by default; browsers may offer their built-in translator.
    document.documentElement.lang = 'pl';
    document.documentElement.removeAttribute('translate');
    document.documentElement.classList.remove('notranslate');
    document.head.querySelectorAll('meta[name="google"][content="notranslate"]').forEach(m => m.remove());
    document.title = 'Trening Funkcjonalny 365™ — Cały rok zajęć funkcjonalnych, gotowy';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'pl'
    });
    ensureMeta({
      name: 'language',
      content: 'Polish'
    });
    ensureMeta({
      name: 'description',
      content: 'Trening Funkcjonalny 365: 6 tomów, 365 gotowych sesji i 5 strategicznych bonusów. Cały rok zajęć treningu funkcjonalnego gotowy już dziś za 79 zł. Bezpieczna płatność w złotówkach.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_MOCKUP,
      fetchpriority: 'high'
    });
    // Warm up the checkout connection so CTA clicks navigate instantly.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
    // Once the page is idle, fetch the checkout in the background so the
    // buy buttons open it instantly.
    whenIdle(() => prefetchPage(PRODUCTS.tf365.checkoutUrl), 4000);
  }, []);
  return <div lang="pl" className="min-h-screen w-full bg-slate-950 text-slate-300 selection:bg-blue-600 selection:text-white" data-id="element-0" data-mp="1m78z15n587yk">
      <MetaPixel data-id="element-1" data-mp="aq9c6pjkelbx" />
      <SocialProofPopup data-id="element-2" data-mp="aqsita3rlnan" />
      <ExitIntentModal data-id="element-3" data-mp="arbyek5xzzli" />
      <AnnouncementBar data-id="element-4" data-mp="qx5hw2u8iwcl" />
      <main data-id="element-5" data-mp="qxf7vqfa53ia">
        <Hero data-id="element-6" data-mp="qy72oz11yx7i" />
        <SocialProof data-id="element-7" data-mp="qyqc1rcn0d9x" />
        <Testimonials1 data-id="element-8" data-mp="qz8h9dha21tz" />
        <Problem data-id="element-9" data-mp="m6p42hmi58pp" />
        <ProductTomos data-id="element-10" data-mp="m65jet5gw67z" />
        <Bonuses data-id="element-11" data-mp="m5ngxes7ovrm" />
        <UrgencyCounter data-id="element-12" data-mp="m548qpsd5lqs" />
        <Pricing data-id="element-13" data-mp="h7c6p2y08j8v" />
        <Testimonials2 data-id="element-14" data-mp="h6t02idt1ha5" />
        <Guarantee data-id="element-15" data-mp="h841wcnoweym" />
        <FAQ data-id="element-16" data-mp="h7lxgsqviufm" />
        <CostOfNotHaving data-id="element-17" data-mp="h59ecc9dqe0z" />
        <FinalCTA data-id="element-18" data-mp="c8j3c3cfm8mf" />
      </main>
      <Footer data-id="element-19" data-mp="c9aqcpryqy13" />
      <StickyMobileCTA data-id="element-20" data-mp="c9u6q21yted0" />
    </div>;
}